import React from 'react';
import styles from './About.module.scss'

function About() {
  return (
    <div className={styles.about}>
        <h1>HAND MADE</h1>
        <p>Добро пожаловать в мир хендмейда – там, где вещи оживают под руками мастеров, превращаясь в уникальные творения. Здесь каждая деталь, каждая линия и каждый шов – это результат вдохновения, терпения и любви к делу.</p>
    </div>
  )
}

export default About